export default () => {
    return localStorage.removeItem('app_key')
}